<template>
  <section>
    <UiExtraNarrowContent>
      <h2 class="mb-12">
        {{ article.title }}
      </h2>

      <div v-html="article.contenthtml" />
      <template v-if="blogStore.articleHasTag(article, 'Sharebutton')">
        <UiShareButton>
          <p class="text-gravaadarkbrown mt-4 flex items-center gap-4">
            <svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.7933 39.5081C10.3109 35.3897 9.44254 30.5219 10.3513 25.8185C11.2601 21.1152 13.8835 16.8997 17.7291 13.9636C21.5746 11.0275 26.3778 9.57256 31.2369 9.872C36.096 10.1714 40.6769 12.2047 44.1195 15.5899C47.5622 18.9752 49.6299 23.4797 49.9344 28.2579C50.2389 33.036 48.7593 37.7591 45.7734 41.5405C42.7875 45.322 38.5006 47.9017 33.7176 48.7953C28.9345 49.689 23.9842 48.8351 19.7959 46.3941L12.8767 48.3205C12.5932 48.402 12.2926 48.4071 12.0064 48.3351C11.7203 48.2631 11.4591 48.1168 11.2502 47.9114C11.0414 47.706 10.8926 47.4492 10.8194 47.1678C10.7462 46.8864 10.7513 46.5909 10.8342 46.3121L12.7933 39.5081Z"
                fill="#7D5B1C" />
              <path
                d="M35.0318 40.943C32.838 40.9484 30.6647 40.5275 28.6368 39.7044C26.6089 38.8814 24.7664 37.6724 23.2152 36.147C21.6639 34.6216 20.4345 32.8098 19.5975 30.8158C18.7605 28.8217 18.3324 26.6846 18.3379 24.5274C18.3435 23.0091 18.9607 21.5548 20.0545 20.4831C21.1483 19.4114 22.6294 18.8096 24.1735 18.8096C24.4282 18.8076 24.6788 18.8732 24.8989 18.9994C25.1189 19.1256 25.3003 19.3079 25.424 19.5269L27.8624 23.7076C28.0074 23.9618 28.0818 24.249 28.0781 24.5404C28.0745 24.8318 27.9929 25.1171 27.8415 25.3677L25.8825 28.5852C26.8859 30.7803 28.6729 32.5375 30.9052 33.5242L34.1773 31.5978C34.4321 31.449 34.7222 31.3687 35.0185 31.3651C35.3149 31.3615 35.607 31.4347 35.8654 31.5773L40.117 33.9751C40.3398 34.0966 40.5251 34.275 40.6535 34.4914C40.7818 34.7078 40.8485 34.9542 40.8465 35.2047C40.841 36.7214 40.2273 38.1747 39.1386 39.2491C38.0499 40.3235 36.5741 40.9322 35.0318 40.943Z"
                fill="#EFEDE5" />
            </svg>
            <strong>Share Gravaa with your riding buddies </strong>
          </p>
        </UiShareButton>
      </template>
    </UiExtraNarrowContent>
  </section>

</template>

<script lang="ts" setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();
// Definiera props
const props = defineProps({
  article: {
    type: Object,
    required: true
  }
});
</script>

<style scoped>
@reference "../../assets/css/main.css";

:deep(ul) {
  list-style: none;
  margin: 0;
  padding: 0;
}

:deep(li) {
  @apply text-base lg:text-2xl;
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  /* avstånd mellan kula och text */
  margin-bottom: 2rem;
  /* spacing mellan punkter */
  border-bottom: 1px solid #000;
  /* för att matcha skissen */
  padding-bottom: 2rem;
}



:deep(li)::before {
  content: "";
  flex-shrink: 0;
  width: 0.75rem;
  /* kula storlek */
  height: 0.75rem;
  background-color: currentColor;
  border-radius: 50%;
  margin-top: 0.4em;
  /* optiskt centrerad mot första textraden */
}
</style>